import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { InputAdornment, TextField } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useTranslation } from 'react-i18next'

export default function CapField({
  id,
  value,
  canBeEmpty,
  readOnly,
  sx,
  handleCapChange = () => {},
  ...others
}) {
  const { t } = useTranslation()

  const [localValue, setLocalValue] = useState(value || '')

  useEffect(() => {
    setLocalValue(value || '')
  }, [value])

  const handleChange = (event) => {
    if (Number(event.target.value) >= 0) {
      setLocalValue(Math.floor(Number(event.target.value)))
    } else {
      setLocalValue('')
    }
  }

  const handleBlur = (event) => {
    const inputValue = event.target.value
    const isEmpty =
      inputValue === '' || inputValue === null || inputValue === undefined
    const isNegative = inputValue < 0

    if (isEmpty || isNegative) {
      setLocalValue(canBeEmpty ? '' : value || '')
      if (!canBeEmpty) return
    }

    // No change if value is the same
    if (Number(localValue) === value) {
      return
    }

    handleCapChange(event)
  }

  return (
    <TextField
      data-testid={`cap-${id}`}
      id={id}
      value={localValue === 0 ? 0 : localValue || ''}
      placeholder={t('sessions.caps.amount')}
      type="number"
      size="small"
      sx={{ width: '18ch', ...sx }}
      disabled={readOnly}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        endAdornment: value ? (
          <InputAdornment position="end">
            <EditIcon />
          </InputAdornment>
        ) : null,
      }}
      {...others}
    />
  )
}

CapField.propTypes = {
  id: T.string.isRequired,
  value: T.number,
  canBeEmpty: T.bool,
  readOnly: T.bool,
  sx: T.object,
  others: T.object,
  handleCapChange: T.func,
  canBeZero: T.bool,
}
